import styles from "./autoOrderDescription.module.scss";

function AutoOrderDescription() {
  return (
    <div className={styles.AutoOrderDescription}>
      <h1 className={styles.heading}>Do you order regularly? Try Auto Order!</h1>
      <p className={styles.paragraph}>
        With Auto Order, you only have to order once and then let us do the work for you.
      </p>

      <h1 className={styles.heading}>Always the Best Deal on Price</h1>
      <p className={styles.paragraph}>
        You don&apos;t need to choose the vendor; Net32 will always pick the best price for you.
      </p>

      <h1 className={styles.heading}>Choose How Often the Order is Placed</h1>
      <p className={styles.paragraph}>From options: Once every 2 weeks, Once every month, and Once every 2 months.</p>

      <h1 className={styles.heading}>Manage Your Auto Order at Anytime</h1>
      <p className={styles.paragraph}>
        We&apos;ll send you a reminder before an order is placed. You will have the option to Skip, Pause, or Cancel the
        order.
      </p>
    </div>
  );
}

export default AutoOrderDescription;
